export default __webpack_public_path__ + "static/B0181-b66ee79d70a43174c42977cb1c554f95.png";